export const transformReachData = (data) => {
  if (!Array.isArray(data)) {
    console.error("pageClicks is not an array:", data);
    return [];
  }
    const { reach, date_start, date_stop } = data[0];
  
    const startMonth = new Date(date_start).toLocaleString('default', { month: 'short' });
    const stopMonth = new Date(date_stop).toLocaleString('default', { month: 'short' });
  
    const Reach = [
      { name: startMonth, reach: 0 },
      { name: stopMonth, reach: parseInt(reach, 10) }
    ];
  
    return Reach;
  };
  export const transformImpressionData = (data) => {
    if (!Array.isArray(data)) {
      console.error("pageClicks is not an array:", data);
      return [];
    }
    const { reach,impressions, date_start, date_stop } = data[0];
  
    const startMonth = new Date(date_start).toLocaleString('default', { month: 'short' });
    const stopMonth = new Date(date_stop).toLocaleString('default', { month: 'short' });
  
    const Reach = [
      { name: startMonth, impressions: 0 },
      { name: stopMonth, impressions: parseInt(impressions, 10) }
    ];
  
    return Reach;
  };
 
  export const transformsAgeData = (data) => {
    if (!Array.isArray(data)) {
      console.error("Agedata is not an array:", data);
      return [];
    }
    const ageGroups = ["18-24", "25-34", "35-44", "45-54", "55-64", "65+"];
    const genderMap = { male: {}, female: {}, unknown: {} };
  
    // Initialize the genderMap with age groups and 0 values
    ageGroups.forEach(age => {
      genderMap.male[age] = 0;
      genderMap.female[age] = 0;
      genderMap.unknown[age] = 0;
    });
  
    // Sum the impressions for each age group and gender
    data.forEach(entry => {
      const { impressions, age, gender } = entry;
      if (genderMap[gender] && genderMap[gender][age] !== undefined) {
        genderMap[gender][age] += parseInt(impressions, 10);
      }
    });
  
    // Convert the genderMap to the desired format
    const formatGenderData = (genderData) => {
      const formattedData = [["Name", "Age"]];
      for (const age of ageGroups) {
        formattedData.push([age, genderData[age]]);
      }
      return formattedData;
    };
  
    return {
      new: formatGenderData(genderMap.male),
      old: formatGenderData(genderMap.female)
    //   unknown: formatGenderData(genderMap.unknown)
    };
  };
  export const transformAgeData = (data) => {
    if (!Array.isArray(data)) {
      console.error("Agedata is not an array:", data);
      return [];
    }
    const ageGroups = ["18-24", "25-34", "35-44", "45-54", "55-64", "65+"];
    const genderData = { male: [], female: [] };

    ageGroups.forEach(ageGroup => {
        const maleImpressions = data.filter(entry => entry.age === ageGroup && entry.gender === "male")
                                     .reduce((acc, curr) => acc + parseInt(curr.impressions), 0);
        const femaleImpressions = data.filter(entry => entry.age === ageGroup && entry.gender === "female")
                                       .reduce((acc, curr) => acc + parseInt(curr.impressions), 0);
        genderData.male.push(maleImpressions);
        genderData.female.push(femaleImpressions);
    });
    
    const result = [
      { data: genderData.female,label: 'Female' },
        { data: genderData.male,label: 'Male'  }
    ];
    // console.log(result);

  return result;

  };
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const convertPageClicks = (pageClicks) => {
  if (!Array.isArray(pageClicks)) {
    console.error("pageClicks is not an array:", pageClicks);
    return [];
  }
  return pageClicks.map(clickData => {
    const { clicks, date_start } = clickData[0];
    const monthIndex = new Date(date_start).getMonth();
    return { name: months[monthIndex], clicks: parseInt(clicks, 10) };
  }).reverse();
};
export const convertAdIds = (addid) => {
  if (!Array.isArray(addid)) {
    console.error("pageClicks is not an array:", addid);
    return [];
  }
  return addid.map(clickData => {
    const { adset_id,adsName } = clickData;
    return { id: adset_id, name: adsName?.name};
  });
};
export const convertLinkClicks = (linkClicks) => {
  if (!Array.isArray(linkClicks)) {
    console.error("linkClicks is not an array:", linkClicks);
    return [];
  }
    return linkClicks.map(clickData => {
      const { inline_link_clicks, date_start } = clickData[0];
      const monthIndex = new Date(date_start).getMonth();
      return { name: months[monthIndex], clicks: parseInt(inline_link_clicks, 10) };
    }).reverse();
  };


  export const Clicks = [
    { name: "Jun", uv: 0 },
    { name: "Jul", uv: 0 },
    { name: "Aug", uv: 0 },
    { name: "Sep", uv: 0 },
    { name: "Oct", uv: 0 },
    { name: "Nov", uv: 5 },
  ];
  
  